import React from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

interface IProps {
  onAccept: () => void;
  onExit: () => void;
  isOpen: boolean;
}

const ReviewAcceptModal = ({ onAccept, onExit, isOpen }: IProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      show={isOpen}
      className="modal-large accept-agreement-modal data-protection-modal"
      centered
      onHide={onExit}
    >
      <div className="modal-content">
        <Modal.Header className="modal-header" translate="">
          <h5 className="modal-title">
            {t('review_accept_modal_title')}
          </h5>
        </Modal.Header>

        <Modal.Footer className="modal-footer">
          <div className="container-fluid">
            <div className="row">
              <div className="col-6">
                <button
                  type="button"
                  className="btn action-secondary"
                  data-dismiss="modal"
                  onClick={onExit}
                >
                  {t('review_accept_modal_cancel')}
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn action-primary"
                  onClick={onAccept}
                >
                  {t('review_accept_modal_accept')}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export { ReviewAcceptModal };
